<template>
    <v-container :class="{ 'pa-0' : $vuetify.breakpoint.mobile }">
        <v-slide-group v-if="!$vuetify.breakpoint.mobile"
                       mandatory
                       v-model="collection"
                       class="pa-4"
                       center-active
                       show-arrows="desktop"
                       :prev-icon="mdiChevronLeft"
                       :next-icon="mdiChevronRight"
                       @change="$emit('input', nfts[collection])"
                       @click:next="slideGroupForwardHandler">
            <v-slide-item
                          v-for="nft of nfts" :key="nft.token_id"
                          v-slot="{ active, toggle }">
                <v-card max-width="450"
                        :color="active ? '#B71C1Cff' : 'grey lighten-1'"
                        class="px-1 ma-4"

                        @click="function() { toggleHandler(toggle, nft) }">
                    <v-list-item three-line>
                        <v-list-item-content :style="active ? 'color: white' : ''">
                            <div class="text-overline-mobile text-md-overline mb-4">
                                <a target="_blank" rel="noopener" :href="url(nft.token_id)">{{ nft.token_id }}</a>
                            </div>
                            <div v-if="nft.indexer" class="text-caption">
                                Owner: <span class="font-weight-light">{{ nft.indexer.token_new_owner_account_id.split('.').shift() }}</span>
                            </div>
                            <v-card-title>
                                <div class="d-flex">
                                    <span class="font-weight-medium mr-1">{{ nft.bra.brand }} </span>
                                    <span class="font-weight-light mr-1">{{ nft.bra.name }} </span>
                                    <span class="font-weight-bold">{{ nft.bra.size.band }}</span>
                                    <span class="font-weight-bold text-uppercase mr-1">{{ nft.bra.size.cup }}</span>
                                    <div :style="{ 'background': JSON.parse(nft.bra.color).color }" class="color-swatch">{{ JSON.parse(nft.bra.color).name }}</div>
                                </div>

                            </v-card-title>
                            <v-card-subtitle class="pb-0">
                                <span class="font-weight-bold">creator:</span> {{ nft.parsedUsername.first }} <span class="font-italic font-weight-light">({{ nft.parsedUsername.nickname }})</span> {{ nft.parsedUsername.last }}
                            </v-card-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <video v-if="active" height="300" muted :autoplay="active" class="video-player rounded-xl" :id="`video-${nft.token_id}`" controls>
                        <source :src="webm(nft.token_id)" type="video/webm">
                        <source :src="mp4(nft.token_id)" type="video/mp4">
                    </video>
                    <video v-else height="300" class="video-player rounded-xl" :id="`video-${nft.token_id}`" controls>
                        <source :src="webm(nft.token_id)" type="video/webm">
                        <source :src="mp4(nft.token_id)" type="video/mp4">
                    </video>
                    <v-scale-transition>
                        <v-icon
                                v-if="active"
                                color="white"
                                size="48"
                                v-text="'mdi-close-circle-outline'"></v-icon>
                    </v-scale-transition>

                </v-card>
            </v-slide-item>
            <v-overlay :value="overlay">
                <ts-nft :token_id="nft ? nft.token_id : undefined"></ts-nft>
            </v-overlay>
        </v-slide-group>
        <v-container class="pa-0" v-else>
            <v-flex class="pa-0" v-for="(nft, index) of nfts" :key="nft.token_id">
                <v-card
                        :color="activeNft === `${nft.token_id}` ? '#B71C1Cff' : '#E0E0E0'"
                        class="px-1 mb-4 rounded-lg"
                        @click="function() { toggleHandler(null, nft) }">
                    <v-list-item>
                        <v-list-item-content :style="activeNft === `${nft.token_id}` ? 'color: white' : 'color: #212121'">
                            <div class="text-overline">
                                <a :class="{ 'white-no-decoration' : activeNft === `${nft.token_id}` }" target="_blank" rel="noopener" :href="url(nft.token_id)">{{ nft.token_id }}</a>
                            </div>
                            <div v-if="nft.indexer" class="text-caption">
                                Owner: <span class="font-weight-light">{{ nft.indexer.token_new_owner_account_id.split('.').shift() }}</span>
                            </div>
                            <v-card-title>
                                <div>
                                    <span class="font-weight-medium">{{ nft.bra.brand }} </span>
                                    <span class="font-weight-light">{{ nft.bra.name }} </span>
                                    <span class="font-weight-bold">{{ nft.bra.size.band }}</span>
                                    <span class="font-weight-bold text-uppercase">{{ nft.bra.size.cup }}</span>
                                </div>

                            </v-card-title>
                            <v-card-subtitle class="pb-0">
                                <span class="font-weight-bold">by:</span> {{ nft.parsedUsername.first }} <span class="font-italic font-weight-light">({{ nft.parsedUsername.nickname }})</span> {{ nft.parsedUsername.last }}
                            </v-card-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <video v-if="activeNft" max-height="250" muted :autoplay="activeNft" class="video-player rounded-xl" :id="`video-${nft.token_id}`" controls>
                        <source :src="webm(nft.token_id)" type="video/webm">
                        <source :src="mp4(nft.token_id)" type="video/mp4">
                    </video>
                    <video v-else max-height="250" class="video-player rounded-xl" :id="`video-${nft.token_id}`" controls>
                        <source :src="webm(nft.token_id)" type="video/webm">
                        <source :src="mp4(nft.token_id)" type="video/mp4">
                    </video>
                    <v-scale-transition>
                        <v-icon
                                v-if="activeNft"
                                color="white"
                                size="48"
                                v-text="'mdi-close-circle-outline'"></v-icon>
                    </v-scale-transition>
                </v-card>
                <v-flex v-if="index + 1 === nfts.length" v-intersect="infiniteScrolling"></v-flex>
            </v-flex>
        </v-container>
    </v-container>
</template>
<style scoped>
.color-swatch {
    height: 30px;
}
.active-nft-slide {
    border-radius: 5px;
}
.video-player {
    width: 100%;
}
</style>
<script>
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import TsNft from "./TsNft.vue";

export default {
    name: "TsNftBuyPanel",
    components: {
        TsNft,
    },
    props: {
        value: Object,
    },
    methods: {
        async getStaticMetadata(nft) {
            const response = await fetch(
                `https://${this.github}/${nft.token_id}.json`
            );
            if (!response.ok) throw new Error(response);
            const json = await response.json();
            return json;
        },
        toggleHandler(toggle, nft) {
            if (!toggle && !nft) return;
            const self = this;
            if (toggle) toggle();
            const tokenId = nft.token_id || nft.premint_id;
            if (tokenId) self.activeNft = tokenId;
            self.$nextTick(function () {
                const querySelector = `video[id="video-${tokenId}"]`;
                const activeVideo = document.querySelector(querySelector);
                if (activeVideo) activeVideo.play();
            });
        },
        url(tokenId) {
            return `https://${document.domain}/braNFT/${tokenId}`;
        },
        webm(tokenId) {
            return `https://${this.github}/${tokenId}.webm`;
        },
        mp4(tokenId) {
            return `https://${this.github}/${tokenId}.mp4`;
        },
        async slideGroupForwardHandler() {
            const self = this;
            const nfts = await self.$backend.getNFTs({
                auth: false,
                query: {
                    exclude: self.nfts.map((nft) => nft._id),
                },
            });
            self.$set(self, "nfts", self.nfts.concat(nfts));
        },
        infiniteScrolling(entries, observer, isIntersecting) {
            const self = this;
            entries;
            observer;
            if (!isIntersecting) return;
            if (self.infiniteScroll) return;
            self.infiniteScroll = true;
            this.loading = true;
            setTimeout(() => {
                this.$backend
                    .getNFTs({
                        query: {
                            count:
                                process.env.NODE_ENV === "production" ? 10 : 3,
                            exclude: self.nfts
                                .filter((nft) => nft._id)
                                .map((nft) => nft._id),
                        },
                    })
                    .then((response) => {
                        this.loading = false;
                        console.log(self.nfts.concat(response));
                        self.$set(self, "nfts", self.nfts.concat(response));
                    })
                    .catch((error) => {
                        error;
                        this.loading = false;
                    });
            }, 500);
            setTimeout(() => {
                self.infiniteScroll = false;
            }, 3000);
        },
    },
    data: function () {
        return {
            overlay: false,
            mdiChevronLeft,
            mdiChevronRight,
            nfts: [],
            collection: this.value,
            infiniteScroll: false,
            loading: false,
            activeNft: null,
        };
    },
    computed: {
        nft() {
            return this.nfts.length > 0
                ? this.nfts[this.collection]
                : undefined;
        },
        tld() {
            return document.domain.match(/[^.]*.com/)[0];
        },
        github() {
            return process.env.NODE_ENV === "production"
                ? `github.${this.tld}`
                : `github-development.${this.tld}`;
        },
    },
    mounted() {
        const self = this;
        (async function () {
            const nfts = await self.$backend.getNFTs({ auth: false });
            self.$set(self, "nfts", nfts);
        })();
    },
};
</script>
